// extracted by mini-css-extract-plugin
export default {"home-box":"home_home-box__ddrRt"};